import { Controller } from "@hotwired/stimulus"

// data-controller="crud--upload-multiplo"
// Substitui o <script> inline de _upload_multiplo.html.erb
export default class extends Controller {
  static targets = ["input", "btn", "rm", "list", "count", "icon"]

  connect() {
    this.renderList([])
  }

  choose() {
    this.inputTarget.click()
  }

  remove() {
    this.inputTarget.value = ""
    this.renderList([])
  }

  changed() {
    const input = this.inputTarget
    const files = input.files && input.files.length ? Array.from(input.files) : []
    this.renderList(files)
  }

  // --- private ---

  fileIconClass(file) {
    const name = (file.name || "").toLowerCase()
    const isPdf = file.type === "application/pdf" || name.endsWith(".pdf")

    if (isPdf) return "fas fa-file-pdf text-red-500"
    if (file.type && file.type.startsWith("image/")) return "fas fa-file-image text-green-600"
    return "fas fa-file-alt text-gray-500"
  }

  renderList(files) {
    if (!files || files.length === 0) {
      this.listTarget.innerHTML = '<li class="text-gray-500">Nenhum arquivo selecionado</li>'
      this.countTarget.textContent = "(0)"
      this.rmTarget.style.display = "none"
      this.iconTarget.className = "fas fa-folder-open text-gray-400"
      return
    }

    let html = ""
    for (const f of files) {
      html += `<li class="flex items-center gap-2">`
        + `<i class="${this.fileIconClass(f)}"></i>`
        + `<span class="truncate">${f.name || "Arquivo"}</span>`
        + `</li>`
    }

    this.listTarget.innerHTML = html
    this.countTarget.textContent = `(${files.length})`
    this.rmTarget.style.display = ""
    this.iconTarget.className = "fas fa-folder-open text-gray-500"
  }
}
